import styled from 'styled-components';
import { ReactComponent as ArrowDownIcon } from '@elementary/common-ui/assets/arrow-down-expand.svg';
import { Flex } from '@elementary/common-ui/components';
import { SxProps, Typography } from '@mui/material';

const ArrowDownIconStyled = styled(ArrowDownIcon)<{ $flip: boolean }>`
  transform: ${({ $flip }) => ($flip ? 'rotate(-180deg)' : undefined)};
  transition: transform 0.1s;
  path {
    fill: ${({ theme }) => theme.palette.common.gray2};
  }
`;

const ShowMore = ({
  isExpanded,
  onClick,
  sx,
}: {
  isExpanded: boolean;
  onClick: () => void;
  sx?: SxProps;
}) => (
  <Flex
    sx={{ alignItems: 'center', gap: 0.5, cursor: 'pointer', ...sx }}
    onClick={onClick}
  >
    <ArrowDownIconStyled width={12} $flip={isExpanded} />
    <Typography sx={{ color: 'common.gray2' }} noWrap>
      {`Show ${isExpanded ? 'less' : 'more'}`}
    </Typography>
  </Flex>
);

export default ShowMore;
